import { Component, OnInit } from '@angular/core';
import { FinanceiroService } from './financeiro.service';
import { NotificationService } from '../../core/notification.service';

@Component({
  selector: 'app-historico-list',
  templateUrl: './historico-list.component.html',
  standalone: false
})
export class HistoricoListComponent implements OnInit {
  items: any[] = [];
  loading = false;
  page = 1;
  pageSize = 20;
  total = 0;
  totalPages = 1;

  constructor(
    private financeiroService: FinanceiroService,
    private notification: NotificationService
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;
    this.financeiroService.listarHistorico({ page: this.page, pageSize: this.pageSize }).subscribe({
      next: (res: any) => {
        this.items = res?.data || [];
        this.total = res?.meta?.total || 0;
        this.totalPages = res?.meta?.totalPages || 1;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('[HistoricoList] erro ao carregar histórico', err);
        this.notification.showError('Erro ao carregar histórico financeiro');
        this.loading = false;
      }
    });
  }

  onPageChange(newPage: number) {
    this.page = newPage;
    this.load();
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
